import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "icon",
		d: "M7 14.1667C6.07777 14.1667 5.21111 13.9917 4.39999 13.6417C3.58888 13.2917 2.88333 12.8167 2.28333 12.2167C1.68333 11.6167 1.20833 10.9111 0.858328 10.1C0.508328 9.28889 0.333328 8.42222 0.333328 7.5C0.333328 6.57778 0.508328 5.71111 0.858328 4.9C1.20833 4.08889 1.68333 3.38333 2.28333 2.78333C2.88333 2.18333 3.58888 1.70833 4.39999 1.35833C5.21111 1.00833 6.07777 0.833332 7 0.833332C7.92222 0.833332 8.78888 1.00833 9.6 1.35833C10.4111 1.70833 11.1167 2.18333 11.7167 2.78333C12.3167 3.38333 12.7917 4.08889 13.1417 4.9C13.4917 5.71111 13.6667 6.57778 13.6667 7.5C13.6667 8.42222 13.4917 9.28889 13.1417 10.1C12.7917 10.9111 12.3167 11.6167 11.7167 12.2167C11.1167 12.8167 10.4111 13.2917 9.6 13.6417C8.78888 13.9917 7.92222 14.1667 7 14.1667Z",
		fill: "currentColor"
	})
});
export default SvgCircleFilled;
